import { Divider } from "@mantine/core";

export const Readme = () => {

    return (
        <>
            <h1>Using the Restful to GRPC Proxy</h1>
            <h2>General</h2>
            <div>
                The productive domain of this restful to grpc proxy is <a href="https://rest.api.getsip.ethz.ch">rest.getsip.ethz.ch</a>. After the domain you can just simple at the path corresponding to the documentation. e.g. https://rest.vseth.ethz.ch/sip/people/user to get details of a user from the people-api.
            </div>
            <Divider/>
            <h2>Authorization</h2>
            <div>
                The authorization is similar to the way we already doing it with grpc. Just add to your HTTP request header Authorization="Bearer [your acces token]"
                </div>
            <Divider size="xl"/>
            <h1>How To add new API's</h1>
            <h2>Add HTTP annotation to the proto file</h2>
            <div>
                We builded the proxy setup on hand of this project: <a href="https://github.com/grpc-ecosystem/grpc-gateway">https://github.com/grpc-ecosystem/grpc-gateway</a> and taking help from the google http anntations for proto<br/>
                So this means you need to add to all your rpc endpoints the http annotations including the call method and the path. This are our recommendation for choosing the path and the the call methods.<br/>
                <ul>
                    <li><b>Path:</b> Use as base path the folder structure from the apis repository. e.g. for the mail api we use /vseth/sip/mail</li>
                    <li><b>Call Method:</b> we use different types of calling methods for different types of calls.
                        <ul>
                            <li>GET: Is used for get or list an object. Where the get using the singular of the object name and the list uses the plural.</li>
                            <li>POST: Is used for create an object.</li>
                            <li>PUT: Is used for update an object.</li>
                            <li>DELETE: Is used for delete an object.</li>
                        </ul>
                    </li>
                </ul>
                You can also looked in the already annotated proto file of the peopele-api. <a href="https://gitlab.ethz.ch/vseth/0403-isg/libraries/apis/-/blob/master/sip/people/people.proto?ref_type=heads">People API Proto</a>
            </div>
            <h2>Refresh the Restful Repos</h2>
            <h3>Documentation</h3>
            <div>
            In the <a href="https://gitlab.ethz.ch/vseth/0403-isg/sip-api-apps/proto-restful-swagger-doc">restful documentation repository</a> just pull the newest commit of the apis submodule and then make a new commit in the main repository and a merge request.
            </div>
            <h3>Proxy</h3>
            <div>
                In the <a href="">restful proxy repository</a> follow these steps:
                <ol>
                    <li>pull the newest commit of the submodule `apis`</li>
                    <li>add the new endpoint to the `profiles.json`. At least fill out the productive profile.</li>
                </ol>
                In the end just commit your changes and create a new merge request.
           </div>
        </>
    );
};
